(function () {
  'use strict';

  var STORAGE_KEY = 'laboo_sale_ends_target'; // shared with assets/laboo-countdown.js
  var DURATION_MS = 6261 * 1000; // 1h 44m 21s — mirrors the product-page timer
  var SELECTOR = '.laboo-offer-strip__countdown';

  function readStoredEnd() {
    var raw = null;

    try {
      raw = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      raw = null;
    }

    if (!raw) {
      raw = readCookie(STORAGE_KEY);
    }

    var end = parseInt(raw, 10);
    return isFinite(end) && end > 0 ? end : null;
  }

  function writeStoredEnd(end) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(end));
    } catch (e) {
      try {
        writeCookie(STORAGE_KEY, String(end), 365);
      } catch (e2) {}
    }
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function format(seconds, label) {
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = seconds % 60;
    return (label ? label + ' ' : '') + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
  }

  function init() {
    function tick() {
      var current = Date.now();
      // Re-read the shared end timestamp every tick so this timer stays in
      // lockstep with the product-page timer that shares the same key.
      var end = readStoredEnd();

      if (end === null) {
        // First visit (or unreadable storage): seed a fresh countdown.
        end = current + DURATION_MS;
        writeStoredEnd(end);
      }

      var remaining = Math.floor((end - current) / 1000);

      if (remaining <= 0) {
        // Expired: restart a fresh, full countdown for this visitor.
        end = current + DURATION_MS;
        writeStoredEnd(end);
        remaining = Math.floor(DURATION_MS / 1000);
      }

      var nodes = document.querySelectorAll(SELECTOR);

      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = format(remaining, nodes[i].getAttribute('data-laboo-sale-ends-label') || '');
      }
    }

    tick();
    setInterval(tick, 1000);

    // Re-sync immediately when the tab becomes visible again (background tabs
    // throttle timers, so a returning visitor would otherwise lag behind).
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        tick();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
